/*
 * @Author: edvardchen
 * @Date: 2017-10-12 10:36:40
 * @Last Modified by: edvardchen
 * @Last Modified time: 2017-10-12 10:44:59
 */
// @flow
import urlUtil from './url';

export default (url: string, params: Object): string => {
  const { host, protocol, pathname, query } = urlUtil.parse(url, true);
  return urlUtil.format({
    host,
    protocol,
    pathname,
    query: {
      ...query,
      ...params,
    },
  });
};
